<template>
  <div :class="prefixCls" v-show="show"><slot></slot></div>
</template>

<script>
    const prefixCls = 'tabs-tabpane'
    export default {
        name: 'TabPane',
        props: {
          name: {
            type: String
          },
          label: {
            type: [String, Function],
            default: ''
          },
          disabled: {
            type: Boolean,
            default: false
          }
        },
        created() {
        },
        data() {
            return {
              prefixCls: prefixCls,
              show: true,
              currentName: this.name
            }
        },
        mounted() {
          this.updateNav()
        },
        computed: {},
        methods: {
          updateNav () {
            this.$parent.updateNav();
          }
        },
        watch: {
          name (val) {
            this.currentName = val;
            this.updateNav();
          },
          label () {
            this.updateNav();
          },
          disabled () {
            this.updateNav();
          }
        },
        destroyed() {
          this.updateNav();
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// components/Tabs/pane.vue